export default "__VITE_ASSET__CXlezifY__"